import React, { useEffect, useState } from 'react';
import '../../../index.scss';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';

// material
import Alert from '@material-ui/lab/Alert';
import { isType3, userTypeList } from 'main_consts';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import styled from 'styled-components';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  checkboxChange,
  formatDateTime,
  getColWidthByField,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  selectChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getFindMawbNoList,
  getSearch,
  snackBarRsp,
} from '../../../main_api';
import CheckBox from '../../../components/Material/Checkbox';

import Table from '../../../components/Material/Table/index';
import {
  Imaster,
  IitemQryResult,
  IhawbQryResult,
  IsearchResponse,
} from './type';
import Select from '../../../components/Material/Select';
import { Iobject, Ioption } from '../../../main_type';
import { MasterGrids } from '../../../components/MasterGrids/MasterGrids';

const DivStyle = styled.div`
  border: 3px outset #1c6ea4;
  margin-bottom: 1rem;
`;

/** 分提單查詢 */
const HawbQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 進出口別
    declType: '1',
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 主號
    mawbNo: '',
    // 分號
    hawbNo: '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    // 是否加入時間查詢
    timeCheck: '0',
    endDateValid: false,
    endTimeValid: false,
    startDateValid: false,
    startTimeValid: false,
  };

  const apiName = 'hawbQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [options, setOptions] = useState<Ioption[]>([]);
  const [searchResult, setSearchResult] = useState<IsearchResponse>(
    {} as IsearchResponse
  );
  const [itemQryResult, setItemQryResult] = useState<IitemQryResult[]>([]);
  const [hawbQryResult, setHawbQryResult] = useState<IhawbQryResult>(
    {} as IhawbQryResult
  );

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getExcel(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      hawbNo: master.hawbNo,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    const startDate = formatDateTime(
      master.startDate,
      master.startTime,
      'MMdd'
    );
    const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${
        master.chkCode1.length > 0 ? `${master.chkCode1}_` : ''
      }${startDate}_${EndDate}_分提單查詢.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      hawbNo: master.hawbNo,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { itemQryList = [], hawbQry: hawbQryStatTmp = {} as IhawbQryResult } =
      (result.data.data || {}) as IsearchResponse;
    if (hawbQryStatTmp.hawbNo) {
      if ((itemQryList || [])?.length > 0) {
        setColList([
          {
            headerName: '明細項次',
            field: 'itemsItemNo',
            width: 110,
          },
          { headerName: '進倉時間', field: 'gciDate', width: 200 },
          { headerName: '出倉時間', field: 'gcoDate', width: 200 },
        ]);
        setItemQryResult(itemQryList);
      }
      setHawbQryResult(hawbQryStatTmp);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (
      (master.timeCheck === '1' &&
        (!master.endDateValid ||
          !master.endTimeValid ||
          !master.startDateValid ||
          !master.startTimeValid)) ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
  };

  const getMawbNoOption = async (declType: '1' | '2', hawbNo: string) => {
    if (hawbNo.length > 0) {
      dispatch(setLoadingRedux(true));
      const result = await getFindMawbNoList({
        declType,
        hawbNo,
      });
      snackBarRsp(enqueueSnackbar, result);
      dispatch(setLoadingRedux(false));
      const list = (result.data.data as string[]) || [];
      const option = list.map((val) => {
        return { value: val, label: val };
      });
      setOptions(option);
      setMaster({ ...master, mawbNo: list[0] || '', declType, hawbNo });
    } else {
      setOptions([]);
    }
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">分提單查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 分提單查詢
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <HVcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio "
                required
                name="declType"
                value={master.declType}
                onChange={(e, value) => {
                  radioChange(updateData)(e, value);
                  getMawbNoOption(value as '1' | '2', master.hawbNo);
                }}
                options={[
                  { value: '1', label: '進口' },
                  { value: '2', label: '出口' },
                ]}
              />
            </HVcGrid>
          </Grid>
          <div>
            {/* 20210325 新增權限判斷 */}
            {userType && !isType3(userType) && (
              <Grid container>
                <VcEGrid item xs={12} sm={2} className="input-text">
                  記帳代號：
                </VcEGrid>

                <VcGrid item xs={12} sm={2}>
                  <Input
                    name="chkCode1"
                    disabled={userTypeList.type2.indexOf(userType) !== -1}
                    maxLength={4}
                    value={master.chkCode1}
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </VcGrid>
                <VcGrid item xs={12} sm={3}>
                  {expressName && (
                    <Alert
                      style={{
                        width: '100%',
                        color: 'red',
                        margin: '0 0.5rem',
                        fontSize: '1em',
                      }}
                      severity="info"
                      icon={false}
                    >
                      {expressName}
                    </Alert>
                  )}
                </VcGrid>
              </Grid>
            )}
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                    userType
                  ) !== -1
                    ? '*'
                    : ''}
                  快遞倉站：
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={2}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={3}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                進倉日期區間：
              </VcEGrid>
              <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
                <DateTimeSePickersTyping
                  key={random}
                  required={master.timeCheck === '1'}
                  disabled={master.timeCheck === '0'}
                  updateData={updateData}
                  style={{ maxWidth: 800 }}
                  names={[
                    ['startDate', 'startTime'],
                    ['endDate', 'endTime'],
                  ]}
                  data={master}
                  setDayRange={3}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={2}>
                <CheckBox
                  label="加入時間查詢"
                  checked={master.timeCheck === '1'}
                  name="timeCheck"
                  onChange={(e) => {
                    setMaster((prev) => ({
                      ...prev,
                      startDate: masterDefaultValue.startDate,
                      startTime: masterDefaultValue.startTime,
                      endDate: masterDefaultValue.endDate,
                      endTime: masterDefaultValue.endTime,
                      ...checkboxChange()(['1', '0'])(e),
                    }));
                  }}
                />
              </VcGrid>
            </Grid>
          </div>

          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*分號：</FormTitle>
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  maxLength={35}
                  required
                  value={master.hawbNo}
                  name="hawbNo"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                  onBlur={(e) => {
                    getMawbNoOption(master.declType, e.target.value);
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>主號：</FormTitle>
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Select
                  placeholder="請先填入分號"
                  value={master.mawbNo}
                  onChange={selectChange(updateData)}
                  name="mawbNo"
                  options={options}
                  disabled={options.length === 0}
                />
              </Grid>
              <VcGrid item xs={12} sm={2}>
                {options.length > 1 && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    有多筆主號，請自行選擇
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          </div>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <>
          <DivStyle>
            <Grid container>
              <VcGrid item xs={4} sm={2}>
                記帳代碼： {hawbQryResult.expressId || ''}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                船掛： {hawbQryResult.vesselRegNo || ''}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                艙號： {hawbQryResult.manifNo || ''}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                報單號碼：
                <br /> {hawbQryResult.lastDeclNo || ''}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                報單類別： {hawbQryResult.appType || ''}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                原始報單號碼：
                <br />
                {hawbQryResult.declNo || ''}
              </VcGrid>
            </Grid>

            <Grid container>
              <VcGrid item xs={4} sm={2}>
                櫃號： <br />
                {hawbQryResult.containerNo || ''}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                報關箱號： {hawbQryResult.boxNo || ''}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                通關方式： {hawbQryResult.goodsStat || ''}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                併袋號碼： {hawbQryResult.expBagNo || ''}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                併袋重量： {hawbQryResult.bagWeight || 0}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                申報件數： {hawbQryResult.piece || 0} 件
              </VcGrid>
            </Grid>

            <Grid container>
              <VcGrid item xs={4} sm={2}>
                進倉件數： {hawbQryResult.gciPiece || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                出倉件數： {hawbQryResult.gcoPiece || 0} 件
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                申報重量： {hawbQryResult.weight || 0}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                進倉重量： {hawbQryResult.gciWeight || 0}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                放行時間：
                <br /> {hawbQryResult.relDate || ''}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                進倉時間：
                <br /> {hawbQryResult.gciDate1 || ''}
              </VcGrid>
            </Grid>

            <Grid container>
              <VcGrid item xs={4} sm={2}>
                出倉時間：
                <br /> {hawbQryResult.gcoDate1 || ''}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                最後進倉時間：
                <br /> {hawbQryResult.gciDate2 || ''}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                最後出倉時間：
                <br /> {hawbQryResult.gcoDate2 || ''}
              </VcGrid>
              <VcGrid item xs={12} sm={6}>
                滯留原因： {hawbQryResult.holdReason || ''}
              </VcGrid>
            </Grid>
          </DivStyle>
          <Table
            key={randomValue}
            data={itemQryResult as unknown as Iobject[]}
            columns={colList}
            rowsPerPageOptions={[100, 50, 10]}
            rootProps={{ style: { height: '400px' } }}
            pageSize={100}
          />
        </>
      )}
    </div>
  );
};

export default HawbQry;
